module.exports = __webpack_public_path__ + "static/img/frankknight.ce041a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/testimonial-logos/frankknight.png
// module id = FT8m
// module chunks = 0